import { styled, createTheme, ThemeProvider } from '@mui/system';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/system": { styled, createTheme, ThemeProvider } } } });
export default ClientProvider;
